export default __webpack_public_path__ + "static/media/ic_logo_new.0704bbb5.svg";